import React, { Component } from "react";
import * as XLSX from 'xlsx';

//Import Breadcrumb
import { Row, Col, Card, CardBody, CardTitle, Button, Modal } from "reactstrap";
//Constants
import { API_WEB_URLS } from "../../constants/constAPI";
//Store
import { compose } from "recompose";
import { container } from "../../store/Containers/cntCommon";
import {
  Fn_FillListData,
  togglemodal,
  toggleDeleteConfirm,
  toggleDeleteSuccess,
  Fn_DeleteData,
  Fn_GetReport,
} from "../../store/functions";
import "../Masters/datatables.scss";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";

import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import TableComponent from "./TableComponent";

class pageList_Ledger extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      selectedFormData: {},
      gridData: [],
      confirm_alert: false,
      success_dlg: false,
      dynamic_title: "",
      dynamic_description: "",
      page: 1,
      sizePerPage: 10,
      productData: [],
      ModalData: [],
      showModal: false,
      selectedRows: [],
      searchText: "",
      filteredData : []
    };
    this.obj = this;
    this.breadCrumbTitle = "Masters";
    this.breadCrumbItem = "Stock Data";
    this.modalTitle = "Stock data";
    this.rtPage_Add = "AddLedger";
    this.rtPage_Edit = "EditLedger";
    this.API_URL = API_WEB_URLS.MASTER + "/0/token/StockDataDetails";

    //Event Binding
    this.btnAdd_onClick = this.btnAdd_onClick.bind(this);
    this.btnEdit_onClick = this.btnEdit_onClick.bind(this);
    this.btnDelete_onClick = this.btnDelete_onClick.bind(this);
    this.btnOpen_onClick = this.btnOpen_onClick.bind(this);
    this.API_URL_SAVE = API_WEB_URLS.GetStockData + "/0/token";
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }
  handleKeyDown = event => {
    switch (event.key) {
      case "F1":
        event.preventDefault();
        this.props.history.push("/dashboard");
        break;
      default:
        break;
    }
  };
  async componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown);

    const obj = JSON.parse(localStorage.getItem("authUser"));
   const data = await Fn_FillListData(this.obj, "gridData", this.API_URL + "/Id/0");

   console.log(data.data.dataList);
   this.setState({filteredData:data.data.dataList})
  }
  btnAdd_onClick(event, values) {
    this.props.history.push(`${this.rtPage_Add}`);
  }
  btnEdit_onClick(Id) {
    this.props.history.push(`${this.rtPage_Edit}/${Id}`, {});
  }
  btnDelete_onClick(formData) {
    Fn_DeleteData(this.obj, formData.Id, this.API_URL, this.API_URL + "/Id/0");
  }
  btnOpen_onClick(row) {
    const vformData = new FormData();

    vformData.append("F_GodownMaster", row.F_GodownMaster);
    vformData.append("F_ItemMaster", row.F_ItemMaster);
    vformData.append("F_ItemTypeMaster", row.F_ItemTypeMaster);

    Fn_GetReport(
      this.obj,
      { arguList: { id: 0, formData: vformData } },
      this.API_URL_SAVE,
      "ModalData",
      true
    ).then(() => {
      this.toggleModal(); // Show modal after data is loaded
    });
  }
  handleRowSelect = (Id) => {
    console.log(Id);
    this.setState(prevState => {
      let updatedSelection;
      if (Id === "all") {
        updatedSelection =
          prevState.selectedRows.length === prevState.filteredData.length
            ? []
            : prevState.filteredData.map(row => row.Id);
      } else {
        updatedSelection = prevState.selectedRows.includes(Id)
          ? prevState.selectedRows.filter(rowId => rowId !== Id)
          : [...prevState.selectedRows, Id];
      }
      return { selectedRows: updatedSelection };
    });
  };
  handleSearch = (searchText) => {
    if (searchText === "") {
      this.setState({ gridData: this.state.filteredData, searchText });
    } else {
      const filteredData = this.state.filteredData.filter(item =>
        Object.keys(item).some(key =>
          item[key] !== null && item[key].toString().toLowerCase().includes(searchText.toLowerCase())
        )
      );
      this.setState({ gridData: filteredData, searchText });
    }
  };
  // renderGridHeader() {
  //   return (
  //     <>
  //       <th>Name</th>
  //       <th>Ledger Group Name</th>
  //       <th>Phone</th>
  //       <th>Email</th>

  //     </>
  //   );
  // }

  toggleModal = () => {
    this.setState(prevState => ({
      showModal: !prevState.showModal,
    }));
  };

  render() {
    const columns = [
      { key: "GodownMaster", label: "Godown Master", sortable: true },
      { key: "ItemName", label: "Item Name", sortable: true },
      { key: "Alias", label: "Alias", sortable: true },
      { key: "ColorName", label: "Color Name", sortable: true },
      { key: "Quantity", label: "Quantity", sortable: true },
      {
        key: "Open",
        label: "Open",
      },
    ];

    const defaultSorted = [
      {
        dataField: "id",
        order: "asc",
      },
    ];

    const pageOptions = {
      sizePerPage: 10,
      totalSize: this.state.gridData, // replace later with size(customers),
      custom: true,
    };
    const selectRow = {
      mode: "checkbox",
    };
    const { SearchBar } = Search;

    const exportToExcel = () => {
      const { selectedRows, filteredData } = this.state;
      const dataToExport = filteredData
        .filter(item => selectedRows.includes(item.Id))
        .map(({ Id,F_ItemTypeMaster, F_ItemMaster, F_GodownMaster, ...rest }) => rest); // Exclude specified fields
      const worksheet = XLSX.utils.json_to_sheet(dataToExport);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Selected Rows");
      XLSX.writeFile(workbook, "SelectedRows.xlsx");
    };

    return (
      <div className="page-content">
        <div className="search-container">
        <Row>
          <Col>
          <input
            type="text"
            className="form-control"
            placeholder="Search..."
            onChange={(e) => this.handleSearch(e.target.value)}
          />
          </Col>
          <Col> <Button color="primary"  onClick={() => this.handleSearch(this.state.searchText)}>Search</Button></Col>
          <Col><Button color="success" onClick={exportToExcel}>Export to Excel</Button></Col>
        </Row>
         
          
        </div>
        
        <TableComponent
          data={this.state.gridData || []}
          columns={columns}
          selectedRows={this.state.selectedRows}
          onRowSelect={this.handleRowSelect}
          handleSearch={this.handleSearch}
          btnOpen_onClick = {this.btnOpen_onClick}
        />

        <Modal
          isOpen={this.state.showModal}
          toggle={this.toggleModal}
          size="lg"
        >
          <div className="modal-header">
            <h5 className="modal-title">Stock Details</h5>
            <button type="button" className="close" onClick={this.toggleModal}>
              <span>&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="table-responsive">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Item Type</th>
                    <th>Godown</th>
                    <th>Item</th>
                    <th>Voucher No</th>
                    <th>Date</th>
                    <th>Quantity</th>
                    <th>Stock Type</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.ModalData.map((item, index) => (
                    <tr key={index}>
                      <td>{item.ItemTypeName}</td>
                      <td>{item.GodownName}</td>
                      <td>{item.ItemName}</td>
                      <td>{item.VoucherNo}</td>
                      <td>{new Date(item.VoucherDate).toLocaleDateString()}</td>
                      <td>{item.Qty}</td>
                      <td>{item.StockInOut}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
export default compose(container)(pageList_Ledger);
